module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/urban-sketching.json
// module id = 359
// module chunks = 146098236253633